/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { DashboardSection } from '../dashboard';
import { CustomInitiatives, CustomReportType } from '../../types/custom-report';
import CustomReportEditFormSubsidiary from './CustomReportEditFormSubsidiary';
import './styles.scss';

interface CustomReportManageSubsidiaryProps {
  customReport?: CustomInitiatives;
  handleReload: () => Promise<void>;
}

const CustomReportManageSubsidiary = (props: CustomReportManageSubsidiaryProps) => {
  const { customReport, handleReload } = props;

  return (
    <>
      <DashboardSection
        title={'Subsidiary comparison report builder'}
      >
        <div className='mt-4'>
          <CustomReportEditFormSubsidiary customReport={customReport} type={CustomReportType.Initiatives} handleReload={handleReload} />
        </div>

      </DashboardSection>
    </>
  )
}

export default CustomReportManageSubsidiary;
